import { find, remove } from 'lodash-es'
import { defineStore } from 'pinia'

import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'

import {
  createBookmarkFolder,
  deleteBookmarkFolder,
  fetchBookmarkFolders,
  updateBookmarkFolder,
} from 'src/api/user.js'
import { pollingActions } from 'src/services/poller/poller.js'

export const useBookmarkFoldersStore = defineStore('bookmarkFolders', {
  state: () => ({
    poller: null,
    allFolders: [],
  }),
  getters: {
    findBookmarkFolderName() {
      return (id) => {
        const folder = this.allFolders.find((folder) => folder.id === id)

        if (!folder) return
        return folder.name
      }
    },
  },
  actions: {
    // every four minutes
    ...pollingActions((store) => store.loadBookmarkFolders(), 240000),
    loadBookmarkFolders() {
      if (!useInstanceCapabilitiesStore().pleromaBookmarkFoldersAvailable) {
        return Promise.resolve()
      }
      return fetchBookmarkFolders({}).then(({ data: folders }) =>
        this.setBookmarkFolders(folders),
      )
    },
    setBookmarkFolders(value) {
      this.allFolders = value
    },
    setBookmarkFolder({ id, name, emoji, emoji_url: emojiUrl }) {
      const entry = find(this.allFolders, { id })
      if (!entry) {
        this.allFolders.push({ id, name, emoji, emoji_url: emojiUrl })
      } else {
        entry.name = name
        entry.emoji = emoji
        entry.emoji_url = emojiUrl
      }
    },
    createBookmarkFolder({ name, emoji }) {
      return createBookmarkFolder({
        name,
        emoji,
      }).then(({ data: folder }) => {
        this.setBookmarkFolder(folder)
        return folder
      })
    },
    updateBookmarkFolder({ folderId, name, emoji }) {
      return updateBookmarkFolder({
        folderId,
        name,
        emoji,
      }).then(({ data: folder }) => {
        this.setBookmarkFolder(folder)
        return folder
      })
    },
    deleteBookmarkFolder({ folderId }) {
      deleteBookmarkFolder({
        folderId,
      })
      remove(this.allFolders, (folder) => folder.id === folderId)
    },
  },
})
